'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('babel-runtime/helpers/defineProperty'));
var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var _slicedToArray = _interopDefault(require('babel-runtime/helpers/slicedToArray'));
var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var lodash = require('lodash');
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var _JSON$stringify = _interopDefault(require('babel-runtime/core-js/json/stringify'));

var Http = function () {
  function Http() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Http);

    _Object$assign(this, {
      config: {
        host: '',
        basePath: ''
      }
    });
    _Object$assign(this.config, config);
    if (typeof window.fetch !== 'function') {
      throw new Error('missing fetch');
    }
  }

  _createClass(Http, [{
    key: '_stripData',
    value: function _stripData(data, strip) {
      if (strip) {
        return lodash.get(data, strip);
      }
      return data;
    }
  }, {
    key: 'get',
    value: function get$$1(filename) {
      var _this = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$update = _ref.update,
          update = _ref$update === undefined ? false : _ref$update,
          _ref$json = _ref.json,
          json = _ref$json === undefined ? {} : _ref$json;

      return new _Promise(function (resolve, reject) {
        var _ref2 = (typeof json === 'undefined' ? 'undefined' : _typeof(json)) === 'object' ? json : {},
            strip = _ref2.strip;

        var arg = '';
        if (update) {
          arg = '?_=' + new Date().getTime();
        }
        var _config = _this.config,
            _config$host = _config.host,
            host = _config$host === undefined ? '' : _config$host,
            _config$basePath = _config.basePath,
            basePath = _config$basePath === undefined ? '' : _config$basePath;

        var baseUrl = '' + host + basePath;
        window.fetch('' + baseUrl + filename + arg).then(function (res) {
          return res.text();
        }).then(function (text) {
          try {
            return JSON.parse(text);
          } catch (e) {
            return text;
          }
        }).then(function (data) {
          if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
            resolve(_this._stripData(data, json.strip));
          } else {
            if (json.strip || json === true) {
              throw new Error('not valid json');
            } else {
              resolve(data);
            }
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }]);

  return Http;
}();

var storage = {};

var defaultPrefix = 'sto:';
var prefix = '';

function setPrefix(pre) {
  if (!prefix) {
    prefix = pre;
  } else {
    throw new Error('prefix has already set as ' + prefix);
  }
}

function set(key, json) {
  return new _Promise(function (resolve, reject) {
    if (!prefix) {
      setPrefix(defaultPrefix);
    }
    var str = _JSON$stringify(json);
    storage[key] = str;
    localStorage.setItem('' + prefix + key, str);
    resolve();
  });
}

function get$1(key, json) {
  return new _Promise(function (resolve, reject) {
    var stored = storage[key];
    if (!prefix) {
      setPrefix(defaultPrefix);
    }
    if (!stored) {
      stored = localStorage.getItem('' + prefix + key);
      if (stored) {
        storage[key] = stored;
      }
    }
    if (stored) {
      return resolve(JSON.parse(stored));
    }
    return reject('no data');
  });
}

var storage$1 = {
  setPrefix: setPrefix,
  set: set,
  get: get$1
};

var _config = {
  base: '/',
  ext: '.json'
};

storage$1.setPrefix('snap:');

var Snapmongo$1 = function () {
  function Snapmongo(collection) {
    var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Snapmongo);

    _Object$assign(this, {
      schema: {
        fields: [],
        detailFields: []
      },
      name: '',
      isPending: false,
      isError: false,
      isReady: false,
      pendingResolves: [],
      pendingRejects: [],
      catalog: null,
      // overrides: { lists: [], details: {} },
      lists: [],
      details: {},
      http: {},
      catalogName: 'index',
      config: {
        ext: _config.ext,
        base: _config.base
      }
    });
    this.name = collection;
    _Object$assign(this.config, conf);
    this.http = new Http(this.config);
    this._requestCatalog().catch(function (err) {
      console.error(err);
      throw err;
    });
  }

  _createClass(Snapmongo, [{
    key: '_getFilename',
    value: function _getFilename(name) {
      return this.config.base + '/' + this.name + '/' + name + this.config.ext;
    }
  }, {
    key: '_addList',
    value: function _addList(list) {
      _Object$keys(list).forEach(function (id) {
        list[id]._id = id;
      });
      this.lists.push(list);
    }
  }, {
    key: '_requestList',
    value: function _requestList(listName) {
      var _this = this;

      return this.http.get(this._getFilename(listName), {
        json: true
      }).then(function (data) {
        if (!data.list || !data.meta) {
          throw new Error('missing list and/or meta in the json');
        }
        _this._addList(data.list);
        if (data.meta && data.meta.nextList) {
          return _this._requestList(data.meta.nextList);
        }
        return _this.lists.length;
      });
    }
  }, {
    key: '_requestCatalog',
    value: function _requestCatalog() {
      var _this2 = this;

      if (this.isPending) {
        return new _Promise(function (res, rej) {
          _this2.pendingResolves.push(res);
          _this2.pendingRejects.push(rej);
        });
      }
      this.isPending = true;
      return this.http.get(this._getFilename(this.catalogName), {
        json: true
      }).then(function (data) {
        if (!data.list || !data.meta) {
          throw new Error('missing list and/or meta in the json');
        }
        _this2.catalog = data;
        if (_this2.lists.length === 0) {
          _this2._addList(data.list);
          _Object$assign(_this2.details, data.details);
          var meta = data.meta;

          if (meta.fields) {
            _Object$assign(_this2.schema.fields, meta.fields);
          }
          if (meta.detailFields) {
            _Object$assign(_this2.schema.detailFields, meta.detailFields);
          }
        }
        var listPromise = _Promise.resolve();
        if (_this2.catalog.meta.nextList) {
          listPromise = _this2._requestList(_this2.catalog.meta.nextList);
        }
        return listPromise.then(function () {
          _this2.hasDetails = !!_this2.catalog.meta.detailFields;
          _this2.isReady = true;
          _this2.isPending = false;
          _this2.isError = false;
          _this2.pendingResolves.forEach(function (res) {
            return res(_this2.lists.length);
          });
          _this2.pendingResolves = [];
          _this2.pendingRejects = [];
          return _this2.lists.length;
        });
      }).catch(function (err) {
        _this2.isPending = false;
        _this2.isError = true;
        _this2.pendingRejects.forEach(function (rej) {
          return rej(err);
        });
        _this2.pendingResolves = [];
        _this2.pendingRejects = [];
        throw err;
      });
    }
  }, {
    key: '_getBrief',
    value: function _getBrief(id) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var brief = void 0;
      var idx = lodash.findIndex(this.lists, function (list) {
        brief = list[id];
        return brief;
      });
      var localPromise = options.remoteOnly ? _Promise.resolve([{}]) : storage$1.get('overrides:lists').catch(function () {
        return [{}];
      });
      return localPromise.then(function (localLists) {
        var localBrief = void 0;
        var idx = lodash.findIndex(localLists, function (list) {
          localBrief = list[id];
          return localBrief;
        });
        if (!brief && !localBrief) {
          return null;
        }
        if (brief && _this3.hasDetails) {
          var detail = _this3.details[id];
          if (!detail && brief.hasDetail) {
            _Object$assign(brief, { _missing: true });
          } else {
            _Object$assign(brief, { _missing: false });
          }
        }
        return _Object$assign({}, brief, localBrief);
      });
    }
  }, {
    key: '_getData',
    value: function _getData(id, brief) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!brief.hasDetail) {
        return _Promise.resolve(_Object$assign(brief, { _id: id }));
      }
      var localPromise2 = options.remoteOnly ? _Promise.resolve({}) : storage$1.get('overrides:details').catch(function () {
        return {};
      });
      return localPromise2.then(function (localDetails) {
        var localDetail = localDetails[id];
        var detail = _this4.details[id];
        return _Object$assign({}, brief, detail, localDetail, { _id: id });
      });
    }
  }, {
    key: '_getList',
    value: function _getList() {
      var _this5 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          localLists = _ref.localLists,
          _ref$options = _ref.options,
          options = _ref$options === undefined ? {} : _ref$options;

      var remote = this.lists.reduce(function (reduced, list) {
        return _Object$assign({}, list, reduced);
      }, {});
      var localPromise = (options.remoteOnly ? _Promise.resolve([{}]) : localLists ? _Promise.resolve(localLists) : storage$1.get('overrides:lists').catch(function () {
        return [{}];
      })).then(function (lists) {
        return lists.reduce(function (reduced, list) {
          return _Object$assign({}, list, reduced);
        }, {});
      }).catch(function () {
        return {};
      });

      return localPromise.then(function (local) {
        var merged = _Object$assign({}, remote, local);
        // console.log('merged:', merged, values(merged).map(i=>i._id));
        var ret = lodash.values(merged);
        ret.reverse();
        ret.total = _this5.catalog.meta.total;
        return ret;
      });
    }
  }, {
    key: 'find',
    value: function find(q, options) {
      var _this6 = this;

      if (this.isReady) {
        return this._getList({ options: options });
      } else {
        return this._requestCatalog().then(function () {
          return _this6._getList({ options: options });
        });
      }
    }
  }, {
    key: 'findOne',
    value: function findOne(q, options) {
      var _this7 = this;

      var id = lodash.get(q, '_id') || q;
      var catalogPromise = _Promise.resolve();
      if (!this.isReady) {
        catalogPromise = this._requestCatalog();
      }
      return catalogPromise.then(function () {
        var brief = _this7._getBrief(id, options);
        if (!brief) {
          return resolve(null);
        }
        if (!brief._missing) {
          return _this7._getData(id, brief, options);
        }
        return _this7._requestData(brief).then(function () {
          return _this7._getData(id, brief, options);
        });
      });
    }
  }, {
    key: '_requestData',
    value: function _requestData(brief) {
      var _this8 = this;

      return this.http.get(this._getFilename(brief._detail), {
        json: true
      }).then(function (data) {
        _Object$assign(_this8.details, data.details);
      });
    }
  }, {
    key: '_addArray',
    value: function _addArray(target, src) {
      var _src = [].concat(src);
      lodash.pull(_src, target);
      _src.forEach(function (it) {
        return target.push(it);
      });
    }
  }, {
    key: '_getNewId',
    value: function _getNewId(localLists) {
      return this._getList({ localLists: localLists }).then(function (list) {
        var max = list[0]._id;
        return '' + (parseInt(max, 10) + 1);
      });
    }
  }, {
    key: '_saveOverrides',
    value: function _saveOverrides(lists, details) {
      return _Promise.all([storage$1.set('overrides:lists', lists), storage$1.set('overrides:details', details)]);
    }
  }, {
    key: '_updateSchema',
    value: function _updateSchema(fields, detailFields) {
      var schema = this.schema;

      this._addArray(schema.fields, fields);
      this._addArray(schema.detailFields, detailFields);
    }
  }, {
    key: '_splitDocument',
    value: function _splitDocument(doc) {
      var details = doc._details ? doc._details : {};
      var detailFields = _Object$keys(details);
      delete doc._details;
      var fields = _Object$keys(doc);
      this._addArray(detailFields, lodash.intersection(fields, this.schema.detailFields));
      lodash.pull.apply(undefined, [fields].concat(_toConsumableArray(detailFields)));
      return [doc, details, fields, detailFields];
    }
  }, {
    key: 'insert',
    value: function insert(obj) {
      var _this9 = this;

      return _Promise.all([storage$1.get('overrides:lists').catch(function (err) {
        return [];
      }), storage$1.get('overrides:details').catch(function (err) {
        return {};
      })]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            _lists = _ref3[0],
            _details = _ref3[1];

        if (!_lists[0]) {
          _lists.push({});
        }
        return _this9._getNewId(_lists).then(function (id) {
          var _splitDocument2 = _this9._splitDocument(_Object$assign({}, obj, { _id: id, _local: 'new' })),
              _splitDocument3 = _slicedToArray(_splitDocument2, 4),
              brief = _splitDocument3[0],
              details = _splitDocument3[1],
              fields = _splitDocument3[2],
              detailFields = _splitDocument3[3];

          _this9._updateSchema(fields, detailFields);
          _details = _extends({}, _details, _defineProperty({}, id, details));
          var list = _lists[0];
          list[id] = brief;
          return _this9._saveOverrides(_lists, _details);
        });
      });
    }
  }, {
    key: '_getListForId',
    value: function _getListForId(lists, id) {
      var idx = lodash.findIndex(lists, function (list) {
        return !!list[id];
      });
      if (idx >= 0) {
        return lists[idx];
      }
      return null;
    }
  }, {
    key: 'update',
    value: function update(q, obj) {
      var _this10 = this;

      var id = '' + (lodash.get(q, '_id') || q);
      return _Promise.all([storage$1.get('overrides:lists').catch(function (err) {
        return [];
      }), storage$1.get('overrides:details').catch(function (err) {
        return {};
      })]).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _lists = _ref5[0],
            _details = _ref5[1];

        if (!_lists[0]) {
          _lists.push({});
        }
        // console.log(_lists, _details);

        var _splitDocument4 = _this10._splitDocument(_Object$assign({}, obj, { _id: id, _local: 'update' })),
            _splitDocument5 = _slicedToArray(_splitDocument4, 4),
            brief = _splitDocument5[0],
            details = _splitDocument5[1],
            fields = _splitDocument5[2],
            detailFields = _splitDocument5[3];

        _this10._updateSchema(fields, detailFields);
        _Object$assign(_details, _defineProperty({}, id, _this10.details[id]), _defineProperty({}, id, details));
        var list = _this10._getListForId(_lists, id) || _lists[0];
        var remoteList = _this10._getListForId(_this10.lists, id);
        _Object$assign(list, remoteList && _defineProperty({}, id, remoteList[id]), _defineProperty({}, id, brief));
        // console.log('after:', _lists, _details);
        return _this10._saveOverrides(_lists, _details);
      });
    }
  }, {
    key: 'dumpUpdated',
    value: function dumpUpdated() {
      var _this11 = this;

      return _Promise.all([this._getList(), storage$1.get('overrides:lists').catch(function (err) {
        return [];
      }), storage$1.get('overrides:details').catch(function (err) {
        return {};
      })]).then(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 3),
            orgList = _ref8[0],
            localLists = _ref8[1],
            localDetails = _ref8[2];

        if (localLists.length === 0) {
          return {};
        }
        var meta = _Object$assign({}, _this11.catalog.meta, {
          total: orgList.length,
          fields: _this11.schema.fields,
          detailFields: _this11.schema.detailFields
        });
        var list = _Object$assign({}, _this11.catalog.list, lodash.mapValues(localLists.reduce(function (memo, list) {
          return _Object$assign({}, memo, list);
        }), function (item) {
          return lodash.omit(item, '_local');
        }));

        var details = _Object$assign({}, _this11.catalog.details, localDetails);
        return {
          filename: 'index.json',
          data: {
            meta: meta,
            list: list,
            details: details
          }
        };
      });
    }
  }]);

  return Snapmongo;
}();

Snapmongo$1.config = function (_ref9) {
  var base = _ref9.base,
      ext = _ref9.ext;

  _Object$assign(_config, {
    base: base,
    ext: ext
  });
};

exports.Snapmongo = Snapmongo$1;
exports['default'] = Snapmongo$1;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/snapmongo/dist/index.js
// module id = 562
// module chunks = 0